import * as yup from 'yup'

export const expertSkillsSchema = yup.object({
  areaSkills: yup.array(
    yup.object({
      id: yup.string(),
      portugueseName: yup.string(),
      englishName: yup.string(),
      spanishName: yup.string()
    })
  ).nullable(),
  domainSkills: yup.array(
    yup.object({
      id: yup.string(),
      portugueseName: yup.string(),
      englishName: yup.string(),
      spanishName: yup.string()
    })
  ).nullable(),
})
